var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"percent-container"},[_c('span',{staticClass:"progress-percent"},[_vm._v(_vm._s(_vm.progress)+" / "+_vm._s(_vm.required))])]),_c('div',{staticClass:"current-progress",style:(`width:${_vm.getProgressPercent()}%;`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }